import { Outlet } from 'react-router';
import { mergeMeta } from '~/utils/mergeMeta'

export const meta = mergeMeta(() => [{ title: 'Heja | Sign in' }])

export default function SigninLayout() {
  return (
    <div className="flex-1 flex flex-col px-4 justify-center items-center h-full bg-gradient-to-br from-primary-color to-secondary-color to-90% from-30%">
      <Outlet />
    </div>
  )
}
